import { Component, Input, OnInit } from '@angular/core';
import { Airport } from '../models/airport.model';
import { NOTAM } from '../models/notam.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tfr-alert',
  templateUrl: './tfr-alert.component.html',
  styleUrls: ['./tfr-alert.component.scss']
})
export class TfrAlertComponent implements OnInit {
  @Input() airport: Airport;

  getActiveTFRs(): NOTAM[] {
    const activeTFRs: NOTAM[] = [];
    this.airport.tfrs.forEach( (notam) => {
      if (this.getTFRStatus(notam) === 'ACTIVE') {
        activeTFRs.push(notam);
      }
    });
    activeTFRs.sort((a, b) => a.effectiveDate.getTime() - b.effectiveDate.getTime());
    return activeTFRs;
  }

  getScheduledTFRs(): NOTAM[] {
    const scheduledTFRs: NOTAM[] = [];
    this.airport.tfrs.forEach( (notam) => {
      if (this.getTFRStatus(notam) === 'SCHEDULED') {
        scheduledTFRs.push(notam);
      }
    });
    scheduledTFRs.sort((a, b) => a.effectiveDate.getTime() - b.effectiveDate.getTime());
    return scheduledTFRs;
  }

  constructor(private _router: Router) { }

  ngOnInit() {
  }

  getTFRStatus(tfr: NOTAM): string {
    const currentDate = new Date();
    if (tfr.expirationDate) {
      if (tfr.effectiveDate.getTime() < currentDate.getTime() && currentDate.getTime() < tfr.expirationDate.getTime()) {
        return 'ACTIVE';
      } else if (tfr.effectiveDate.getTime() > currentDate.getTime() && currentDate.getTime() < tfr.expirationDate.getTime()) {
        return 'SCHEDULED';
      } else {
        return 'EXPIRED';
      }
    } else {
      if (tfr.effectiveDate.getTime() < currentDate.getTime()) {
        return 'ACTIVE';
      } else if (tfr.effectiveDate.getTime() > currentDate.getTime()) {
        return 'SCHEDULED';
      } else {
        return 'ERROR';
      }
    }
  }

  formatTitle(tfr: NOTAM): string {
    let result = '';
    result += this.getTFRStatus(tfr);
    result += ' TFR: ';
    if (tfr.notamId) {
      result += tfr.notamId;
    }

    /* if (tfr.effectiveDate) {
      if (result) {
        result += ' - ';
      }
      result += 'EFFECTIVE ' + this.formatDate(tfr.effectiveDate);
    }

    if (tfr.expirationDate === null) {
      if (result) {
        result += ' - ';
      }
      result += 'FURTHER NOTICE';
    } else {
      if (result) {
        result += ' - ';
      }
      result += 'EXPIRES ' + this.formatDate(tfr.expirationDate);
    } */
    return result;
  }

  formatDate(input: Date): string {
    return (input.getMonth() + 1) + '/' + input.getDate() + '/' + input.getFullYear();
  }

  navigateToTFRs() {
    let tempUrl = this._router.url;
    if (this._router.url.indexOf('?') > 0) {
      tempUrl = this._router.url.substr(0, tempUrl.indexOf('?'));
    }
    if (this._router.url.indexOf('#') > 0) {
      tempUrl = this._router.url.substr(0, tempUrl.indexOf('#'));
    }
    this._router.navigate([tempUrl], {fragment: 'notams'});
  }
}
